export const SHHETS_CONFIG = [
  {
    key: "google_sheets",
    title: "Google Planilhas",
    subtitle: "Gerencie suas listagens online",
    text: "Facilite a organização e o envio de suas listagens utilizando a integração com o Google Planilhas.",
    icon: "Google",
    features: [
      "Facilidade na organização",
      "Envio de dados dinâmicos",
      "Integração em tempo real",
      "Importação e exportação de dados"
    ],
    tag: "Integração Online",
    route: "/listagens/adicionar/google",
  },
  {
    key: "api_integration",
    title: "Requisição Web (API)",
    subtitle: "Adicione listagens automaticamente",
    text: "A integração via API permite adicionar e atualizar listagens de forma dinâmica e escalável.",
    icon: "API",
    features: [
      "Integração dinâmica",
      "Automação de processos",
      "Escalabilidade",
      "Atualização em tempo real"
    ],
    tag: "Integração Dinâmica",
    route: "/listagens/adicionar/api",
  },
  {
    key: "excel_file",
    title: "Arquivo Excel",
    subtitle: "Importe listagens de arquivos excel",
    text: "Crie uma listagem a partir da importação de um arquivo Excel.",
    icon: "Newspaper",
    features: [
      "Importação de dados de arquivos",
      "Criação de listagens em massa",
      "Exportação fácil",
      "Gerenciamento de dados offline"
    ],
    tag: "Importação de Dados",
    route: "/listagens/adicionar/excel",
  }
];
